var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"f-bottom"},[_c('div',[_c('a',{attrs:{"href":"//beian.miit.gov.cn/","target":"_blank"}},[_vm._v("沪ICP备2023034837号")])])])])])
}]

export { render, staticRenderFns }